package com.stevdza.san.models

import com.stevdza.san.util.Constants
import com.stevdza.san.util.Res

enum class Portfolio(
    val image: String,
    val title: String,
    val description: String,
    val url: String
) {
    One(
        image = Res.Image.portfolio1,
        title = "My Restaurants",
        description = "App/Website",
        url = Constants.PROJECT_MYRESTAURANTS
    ),
    Two(
        image = Res.Image.portfolio2,
        title = "Critical Thinker",
        description = "App/Website",
        url = Constants.PROJECT_CRITICALTHINKER
    ),
    Three(
        image = Res.Image.portfolio3,
        title = "Book Brief",
        description = "App/Website",
        url = Constants.PROJECT_BOOKBRIEF
    ),
    Four(
        image = Res.Image.portfolio4,
        title = "Best Joke",
        description = "App/Website",
        url = Constants.PROJECT_BESTJOKE
    )
    ,
    Five(
        image = Res.Image.portfolio5,
        title = "Scented Frames",
        description = "Instagram Profile",
        url = Constants.PROJECT_SCENTEDFRAMES
    )
    ,
    Six(
        image = Res.Image.portfolio6,
        title = "Advice",
        description = "App/Website",
        url = Constants.PROJECT_ADVICE
    )
}